// App.js
import React from 'react';
import {BrowserRouter as Router, Route, Routes, useSearchParams} from 'react-router-dom';
import Invite from './components/Invite';
import Admin from './components/Admin';
import VotePage from './components/VotePage';
import WinnerPage from './components/WinnerPage';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<InviteWrapper/>}/>
                <Route path="/admin" element={<Admin/>}/>
                <Route path="/vote" element={<VotePage/>}/>
                <Route path="/winner" element={<WinnerPage/>}/>
            </Routes>
        </Router>
    );
}

function InviteWrapper() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    if (!token) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
                <div className="text-center max-w-md mx-4">
                    <h1 className="text-2xl sm:text-3xl font-display mb-4">Свадебное приглашение</h1>
                    <p className="text-gray-600 text-sm sm:text-base mb-6">
                        Для доступа к вашему персональному приглашению используйте ссылку, отправленную вам.
                    </p>
                    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm">
                        <p className="text-xs sm:text-sm text-gray-500">
                            Если у вас возникли проблемы с доступом, пожалуйста, свяжитесь с нами.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return <Invite token={token}/>;
}

export default App;